import Properties from './Properties.js';
export default Properties;
//# sourceMappingURL=index.js.map